import styled, { css } from "styled-components";
import { EmptyState } from "components/common/modals/modal.styles";
import { MoreChevronButton } from "components/common/MoreChevronButton/index.styles";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TotalDonorsNumber = styled.p`
  color: #fe2f67;
  font-weight: 600;
  font-size: 35px;
  margin: 0;
  line-height: 1;
`;

export const TopDonorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DownloadButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const DownloadCsvText = styled.span`
  font-size: 12px;
  color: #333;
  margin-left: 0.25rem;
`;

export const SectionCaption = styled.p`
  font-size: 1rem;
  margin: 0 0 0.5rem;
  font-weight: 600;
`;

export const DonorRow = styled.div`
  display: flex;
  align-items: center;
  background: #f7f4f4;
  border-top: 1px solid #e5e5e5;
  padding: 0.5rem 0.75rem;
  gap: 0.75rem;

  .idx {
    font: 600 14px/1;
    color: #fe2f67;
    font-weight: 700;
  }
`;

export const DonorInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`;

export const DonorName = styled.span`
  font-size: 0.9rem;
  font-weight: 500;
`;

export const DonorDate = styled.span`
  font-size: 0.7rem;
  color: #8f8f8f;
`;

export const DonorAmt = styled.span`
  font: 16px/1;
  color: #fe2f67;
  font-weight: 700;
`;

export const DonorsEmptyState = EmptyState;

export const DonorList = styled.div<{ $scroll?: boolean }>`
  margin-top: 0.5rem;
  border-top: 1px solid #ccc;
  ${({ $scroll }) =>
    $scroll &&
    css`
      overflow-y: auto;
      max-height: 22.5rem;
      transition: max-height 0.3s ease-in-out;
      
      scrollbar-width: thin;
      scrollbar-color: #fe2f67 #f1f1f1;

      &::-webkit-scrollbar {
          width: 8px;
      }
      &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
          background: #fe2f67;
          border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
          background: #e8245a;
      }
    `}
`;

export const DonorsMoreChevronButton = styled(MoreChevronButton)`
    margin-top: 0.5rem;
`; 